(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory(
      'KarcherBuilderReportsViewModel',
      karcherBuilderReportsViewModelFactory
    );

  /** @ngInject */
  function karcherBuilderReportsViewModelFactory(
    DateTime,
    $translate,
    $http,
    hostProtocol,
    hostDomain,
    layoutActions,
    $q,
    AppStateService,
    DayTranslationService
  ) {
    function KarcherBuilderReportsViewModel() {
      this.tableChartData = {};
      this.facilityTimeZone = '';
      this.washFacilityList = [];
      this.placeHolderText = $translate.instant('FACILITY_NAME');
      this.selectedReport = '';
      this.firstRowTableColumnTitle = '';
      this.isChartVisible = false;
      this.isTableVisible = false;
      this.isChartIncluded = false;
      this.subPointList = [];
      this.weatherHistoryData = [];
      this.weatherLocationData = [];
      this.reportNameList = [];
      this.reportBodyData = {};
      this.chartData = this.createChartDataConfig();
      this.dependsOnData = {};
      this.reportConfigurationData = null;
    }

    KarcherBuilderReportsViewModel.prototype.destroy = function () {};

    KarcherBuilderReportsViewModel.prototype.createChartDataConfig =
      function () {
        var that = this;
        return {
          data: null,
          x: {
            tick: {
              rotate: 60,
              multiline: true,
              format: function (item) {
                switch (that.reportBodyData.timeFrame) {
                  case 'HOURLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('DD/MM/YY HH:mm');
                  case 'DAILY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('DD/MM/YY');
                  case 'WEEKLY':
                    that.chartData.x.type = 'x';
                    return item;
                  case 'MONTHLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('MM/YY');
                  case 'YEARLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('YYYY');
                  default:
                    that.chartData.x.type = 'category';
                    that.chartData.x.tick = {
                      rotate: 0,
                      multiline: false,
                      culling: false
                    };
                    return item;
                }
              }
            }
          },
          y: {
            tick: {
              rotate: 60
            }
          }
        };
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsList =
      function (data) {
        this.reportNameList = data;
      };

    KarcherBuilderReportsViewModel.prototype.getReportGrouping = function (
      report
    ) {
      switch (report) {
        case 3:
          this.firstRowTableColumnTitle = $translate.instant('HOURS');
          break;
        case 4:
          this.firstRowTableColumnTitle = $translate.instant('DAY');
          break;
        case 11:
          this.firstRowTableColumnTitle = '';
          break;
        case 14:
          this.firstRowTableColumnTitle = '';
          break;
        case 15:
          this.firstRowTableColumnTitle = '';
          break;
        case 16:
          this.firstRowTableColumnTitle = '';
          break;
        default:
          this.firstRowTableColumnTitle = $translate.instant('DATE');
          break;
      }

      this.chartData = this.createChartDataConfig();
    };

    KarcherBuilderReportsViewModel.prototype.refreshConfigurationData =
      function (data) {
        var that = this;
        this.reportBodyData.timeFrame = 'CUSTOM';
        var stateCheck = AppStateService.getState();
        data.forEach(function (item) {
          if (item.type === 'date-input') {
            // Save to state
            if (!stateCheck.fromModel) {
              AppStateService.setState(
                'fromModel',
                new Date(new DateTime().startOf(DateTime.units.MONTH).timestamp)
              );
            }
            if (!stateCheck.toModel) {
              AppStateService.setState(
                'toModel',
                new Date(new DateTime().endOf(DateTime.units.DAY).timestamp)
              );
            }
            item.model =
              item.label === 'To'
                ? AppStateService.getState().toModel
                : AppStateService.getState().fromModel;
            that.reportBodyData[item.inputName] = new Date(
              item.model
            ).getTime();
            if (item.inputName === 'from') {
              that.reportBodyData.offsetFrom =
                item.model.getTimezoneOffset() * 60000;
            } else {
              that.reportBodyData.offsetTo =
                item.model.getTimezoneOffset() * 60000;
            }
          } else if (
            (item.type === 'multiply-input' || item.type === 'select-input') &&
            item.dependsOn === null &&
            item.selectorPath !== ''
          ) {
            KarcherBuilderReportsViewModel.prototype
              .getDynamicList(item.selectorPath, item.selectorHeader)
              .then(function (data) {
                item.selectorList = data;
                that.washFacilityList = data;
              });
          } else if (
            (item.type === 'multiply-input' || item.type === 'select-input') &&
            item.dependsOn !== null &&
            item.selectorPath !== ''
          ) {
            that.dependsOnData.dependsOn = item.dependsOn;
            that.dependsOnData.inputName = item.inputName;
            that.dependsOnData.selectorPath = item.selectorPath;
          } else {
            item.model =
              (item.selectorList &&
                item.selectorList[0] &&
                item.selectorList[0].id) ||
              '';
            that.reportBodyData[item.inputName] = item.model;
          }
        });
        var inputOrder = { from: 1, to: 2, facilityId: 3, bayId: 4, timeFrame: 5 };
        var labelOrder = { 'From': 1, 'To': 2, 'Select sub point': 4, 'Time frame': 5 };
        function getOrderIndex(it) {
          if (it && it.inputName && inputOrder[it.inputName] !== undefined) {
            return inputOrder[it.inputName];
          }
          if (it && it.label && labelOrder[it.label] !== undefined) {
            return labelOrder[it.label];
          }
          return 100;
        }
        data.sort(function (a, b) {
          return getOrderIndex(a) - getOrderIndex(b);
        });
        this.reportBuilderData = data;
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsData =
      function (data) {
        var temp = {},
          timeArray = [],
          valuePairsArray = [];
        valuePairsArray = [];
        temp.groupsData = [];
        temp.groupsTotal = [];
        temp.total = data.total;
        temp.unit = data.unit;

        // Create groupNames array as template array
        var tempArray = data.values.reduce(function (acc, value) {
          return acc.concat(value.groupName);
        }, []);
        // Remove duplicates from groupNames and sort values
        temp.groupNames = tempArray
          .filter(function (item, index) {
            return tempArray.indexOf(item) === index;
          })
          .sort();

        // Add missing group name in array with 0 value
        for (var i = 0; i < temp.groupNames.length; i++) {
          for (var j = 0; j < data.values.length; j++) {
            if (temp.groupNames[i] !== data.values[j].groupName) {
              if (!data.values[j].groupName.includes(temp.groupNames[i])) {
                data.values[j].value.push(0);
                data.values[j].groupName.push(temp.groupNames[i]);
              }
            }
          }
        }

        // Create group name values pair object
        data.values.forEach(function (item) {
          timeArray.push(item.group);
          var valuePairs = {};
          item.groupName.forEach(function (k, i) {
            valuePairs[k] = item.value[i];
          });
          valuePairs = sortObjectByKeys(valuePairs);
          valuePairsArray.push(valuePairs);
        });

        // Create groupsData
        var that = this;
        valuePairsArray.forEach(function (pairs, i) {
          var groupValue = timeArray[i];
          // Need to be updated with flag form SuperAdmin portal
          if (that.selectedReport === 4) {
            groupValue = DayTranslationService.translateDayNumber(
              parseInt(timeArray[i])
            );
          }
          temp.groupsData.push({
            groupValue: groupValue,
            values: Object.values(pairs)
          });
        });

        // Create groupTotal
        var tempForTotalArray = [];
        temp.groupsData.forEach(function (item) {
          tempForTotalArray.push(item.values);
        });

        temp.groupTotal = tempForTotalArray.reduce(function (r, a) {
          a.forEach(function (b, i) {
            r[i] = (r[i] || 0) + b;
          });
          return r;
        }, []);

        this.chartData.data = temp;
        layoutActions.hideLoader();
        this.isChartVisible = true;
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsTableData =
      function (data) {
        this.tableChartData = data;
        this.isTableVisible = true;
        layoutActions.hideLoader();
      };

    KarcherBuilderReportsViewModel.prototype.refreshWeatherHistoryData =
      function (data) {
        this.weatherHistoryData = data.forecast.forecastday;
        this.weatherLocationData = data.location;
      };

    KarcherBuilderReportsViewModel.prototype.refreshWashFacilityList =
      function (data) {
        this.washFacilityList = data;
      };

    KarcherBuilderReportsViewModel.prototype.getTimezoneForSelectedFacility =
      function (selectedFacility) {
        if (!selectedFacility || !selectedFacility[0] || !selectedFacility[0].timeZone) {
          return;
        }
        this.facilityTimeZone = selectedFacility[0].timeZone;
      };

    KarcherBuilderReportsViewModel.prototype.getDynamicList = function (
      path,
      header
    ) {
      var deferred = $q.defer();
      var acceptHeader =
        header !== '' ? header : 'text/plain, application/json';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: acceptHeader },
        url: hostProtocol + '://' + hostDomain + path
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData.data, errorData.header, errorData.status);
        }
      );

      return deferred.promise;
    };

    return KarcherBuilderReportsViewModel;

    function sortObjectByKeys(object) {
      return Object.keys(object)
        .sort()
        .reduce(function (accumulator, key) {
          accumulator[key] = object[key];
          return accumulator;
        }, {});
    }
  }
})();
